import { device } from "@/style/constants";
import { Spinner } from "@riot-private/ux-react-components";
import React from "react";
import styled from "styled-components";

export const SmallerSpinner = styled(Spinner)`
  margin: 0;
`;

export const Container = styled.div`
  align-self: center;
  height: 35px;
  width: 100%;
  margin: 0 16px;
  border-radius: 6.4px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;

  color: ${({ theme }) => theme.colors["gray-099"]};
  background: rgba(128, 128, 128, 0.2);
  font-size: 13px;
  line-height: 100%;
  white-space: pre;

  margin-top: 40px;

  @media ${device.laptop} {
    height: 32px;
    width: 100%;
    margin: 16px 0 16px 8px;
  }
`;

export const BalanceBuyButton = styled.div`
  height: 16px;
  width: 16px;
  background: rgba(3, 3, 3, 0.2);
  color: black;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  margin-left: 8px;
`;

export const StyledRPText = styled.div`
  color: ${({ theme }) => theme.colors["dark.text-secondary"]};
`;

export const StyledTopupIcon = () => (
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7964 8C16.7964 12.4183 13.2147 16 8.79639 16C4.37811 16 0.796387 12.4183 0.796387 8C0.796387 3.58173 4.37811 0 8.79639 0C13.2147 0 16.7964 3.58173 16.7964 8ZM10.7964 7C10.2441 7 9.79639 6.55228 9.79639 6V4.5C9.79639 4.22386 9.57251 4 9.29639 4H8.29639C8.02026 4 7.79639 4.22386 7.79639 4.5V6C7.79639 6.55228 7.34867 7 6.79639 7H5.29639C5.02026 7 4.79639 7.22386 4.79639 7.5V8.5C4.79639 8.77614 5.02026 9 5.29639 9H6.79639C7.34867 9 7.79639 9.44771 7.79639 10V11.5C7.79639 11.7761 8.02026 12 8.29639 12H9.29639C9.57251 12 9.79639 11.7761 9.79639 11.5V10C9.79639 9.44771 10.2441 9 10.7964 9H12.2964C12.5725 9 12.7964 8.77614 12.7964 8.5V7.5C12.7964 7.22386 12.5725 7 12.2964 7H10.7964Z"
      fill={"rgba(252, 252, 252, 0.8)"}
      fillOpacity="1"
    />
  </svg>
);
